/**
 * Copyright (c) 2000-present Liferay, Inc. All rights reserved.
 *
 * This library is free software; you can redistribute it and/or modify it under
 * the terms of the GNU Lesser General Public License as published by the Free
 * Software Foundation; either version 2.1 of the License, or (at your option)
 * any later version.
 *
 * This library is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the GNU Lesser General Public License for more
 * details.
 */

/*
 * This function gets loaded when all the HTML, not including the portlets, is
 * loaded.
 */
AUI().ready(function () {});

/*
 * This function gets loaded after each and every portlet on the page.
 *
 * portletId: the current portlet's id
 * node: the Alloy Node object of the current portlet
 */
Liferay.Portlet.ready(function (_portletId, _node) {});

/*
 * This function gets loaded when everything, including the portlets, is on
 * the page.
 */
Liferay.on('allPortletsReady', function () {

    const form_body_wrapper = AUI().one('.mag-form-page');
    const initMagForms = function() {
        // currently not binding to any events of form will need to investigate for:
        // 1) Required Fields test -- Text is not in the initial DOM and therefore doesn't load within the allportlets ready
        // 2) Previous / Next doesn't land on the right section of the page. (Observed as issue with LR out the Box.
    }

    const setFormCloseURL = function () {
        let formInstanceIdtoURLMap = [
            { "instanceId" : "4694264", "URL": '/web/ecss/w/member-grievances'}
        ]

        if (form_body_wrapper) {
            formInstanceIdtoURLMap.forEach((item) => {
                let grievance_form = form_body_wrapper.one(`form[data-ddmforminstanceid="${item.instanceId}"]`);
                if (grievance_form) {
                    let close_btn = form_body_wrapper.one('.btn-close');
                    if (close_btn) {
                        close_btn.removeClass('hide');
                        close_btn.on('click', function(){
                            Liferay.Util.navigate(item.URL);
                        });
                    }
                }
            });
        }
    }

    initMagForms();
    setFormCloseURL();

});